export const labels = {
	title: {
		label: "Label.MobileCreator.ErrorDialog.Title",
		default: "Error",
	},
	close: {
		label: "Label.MobileCreator.ErrorDialog.Close",
		default: "Close",
	},
	message: {
		label: "Label.MobileCreator.ErrorDialog.Message",
		default: "This action is not available now. Try again later.",
	},
};
